const actions = {
  PERSON_ADD_BEGIN: 'PERSON_ADD_BEGIN',
  PERSON_ADD_SUCCESS: 'PERSON_ADD_SUCCESS',
  PERSON_ADD_ERR: 'PERSON_ADD_ERR',

  PERSON_READ_BEGIN: 'PERSON_READ_BEGIN',
  PERSON_READ_SUCCESS: 'PERSON_READ_SUCCESS',
  PERSON_READ_ERR: 'PERSON_READ_ERR',

  SINGLE_PERSON_READ_BEGIN: 'SINGLE_PERSON_READ_BEGIN',
  SINGLE_PERSON_READ_SUCCESS: 'SINGLE_PERSON_READ_SUCCESS',
  SINGLE_PERSON_READ_ERR: 'SINGLE_PERSON_READ_ERR',

  PERSON_UPDATE_BEGIN: 'PERSON_UPDATE_BEGIN',
  PERSON_UPDATE_SUCCESS: 'PERSON_UPDATE_SUCCESS',
  PERSON_UPDATE_ERR: 'PERSON_UPDATE_ERR',

  DAILY_WORK_ADD_BEGIN: 'DAILY_WORK_ADD_BEGIN',
  DAILY_WORK_ADD_SUCCESS: 'DAILY_WORK_ADD_SUCCESS',
  DAILY_WORK_ADD_ERR: 'DAILY_WORK_ADD_ERR',


  PERSON_WORK_READ_BEGIN: 'PERSON_WORK_READ_BEGIN',
  PERSON_WORK_READ_SUCCESS: 'PERSON_WORK_READ_SUCCESS',
  PERSON_WORK_READ_ERR: 'PERSON_WORK_READ_ERR',

  EMPLOYEE_DATA_READ_BEGIN: 'EMPLOYEE_DATA_READ_BEGIN',
  EMPLOYEE_DATA_READ_SUCCESS: 'EMPLOYEE_DATA_READ_SUCCESS',
  EMPLOYEE_DATA_READ_ERR: 'EMPLOYEE_DATA_READ_ERR',

  EMPLOYEE_READ_BEGIN: 'EMPLOYEE_READ_BEGIN',
  EMPLOYEE_READ_SUCCESS: 'EMPLOYEE_READ_SUCCESS',
  EMPLOYEE_READ_ERR: 'EMPLOYEE_READ_ERR',


  HOLIDAYS_ADD_BEGIN: 'HOLIDAYS_ADD_BEGIN',
  HOLIDAYS_ADD_SUCCESS: 'HOLIDAYS_ADD_SUCCESS',
  HOLIDAYS_ADD_ERR: 'HOLIDAYS_ADD_ERR',


  HOLIDAY_UPDATE_BEGIN: 'HOLIDAY_UPDATE_BEGIN',
  HOLIDAY_UPDATE_SUCCESS: 'HOLIDAY_UPDATE_SUCCESS',
  HOLIDAY_UPDATE_ERR: 'HOLIDAY_UPDATE_ERR',


  HOLIDAY_DELETE_BEGIN: 'HOLIDAY_DELETE_BEGIN',
  HOLIDAY_DELETE_SUCCESS: 'HOLIDAY_DELETE_SUCCESS',
  HOLIDAY_DELETE_ERR: 'HOLIDAY_DELETE_ERR',


  holidayDeleteBegin: () => {
    return {
      type: actions.HOLIDAY_DELETE_BEGIN,
    };
  },

  holidayDeleteSuccess: (data) => {
    return {
      type: actions.HOLIDAY_DELETE_SUCCESS,
      data,
    };
  },

  holidayDeleteErr: (err) => {
    return {
      type: actions.HOLIDAY_DELETE_ERR,
      err,
    };
  },


  holidayUpdateBegin: () => {
    return {
      type: actions.HOLIDAY_UPDATE_BEGIN,
    };
  },

  holidayUpdateSuccess: (data) => {
    return {
      type: actions.HOLIDAY_UPDATE_SUCCESS,
      data,
    };
  },

  holidayUpdateErr: (err) => {
    return {
      type: actions.HOLIDAY_UPDATE_ERR,
      err,
    };
  },


  holidaysAddBegin: () => {
    return {
      type: actions.HOLIDAYS_ADD_BEGIN,
    };
  },

  holidaysAddSuccess: (data) => {
    return {
      type: actions.HOLIDAYS_ADD_SUCCESS,
      data,
    };
  },

  holidaysAddErr: (err) => {
    return {
      type: actions.HOLIDAYS_ADD_ERR,
      err,
    };
  },




  employeedataReadBegin: () => {
    return {
      type: actions.EMPLOYEE_READ_BEGIN,
    };
  },

  employeedataReadSuccess: (data) => {
    return {
      type: actions.EMPLOYEE_READ_SUCCESS,
      data,
    };
  },

  employeedataReadErr: (err) => {
    return {
      type: actions.EMPLOYEE_READ_ERR,
      err,
    };
  },


  getemployeedataReadBegin: () => {
    return {
      type: actions.EMPLOYEE_DATA_READ_BEGIN,
    };
  },

  getemployeedataReadSuccess: (data) => {
    return {
      type: actions.EMPLOYEE_DATA_READ_SUCCESS,
      data,
    };
  },

  getemployeedataReadErr: (err) => {
    return {
      type: actions.EMPLOYEE_DATA_READ_ERR,
      err,
    };
  },

  singlePersonReadBegin: () => {
    return {
      type: actions.SINGLE_PERSON_READ_BEGIN,
    };
  },

  singlePersonReadSuccess: (data) => {
    return {
      type: actions.SINGLE_PERSON_READ_SUCCESS,
      data,
    };
  },

  singlePersonReadErr: (err) => {
    return {
      type: actions.SINGLE_PERSON_READ_ERR,
      err,
    };
  },

  personAddBegin: () => {
    return {
      type: actions.PERSON_ADD_BEGIN,
    };
  },

  personAddSuccess: (data) => {
    return {
      type: actions.PERSON_ADD_SUCCESS,
      data,
    };
  },

  personAddErr: (err) => {
    return {
      type: actions.PERSON_ADD_ERR,
      err,
    };
  },

  personDeleteBegin: () => {
    return {
      type: actions.PERSON_DELETE_BEGIN,
    };
  },

  personDeleteSuccess: (data) => {
    return {
      type: actions.PERSON_DELETE_SUCCESS,
      data,
    };
  },

  personDeleteErr: (err) => {
    return {
      type: actions.PERSON_DELETE_ERR,
      err,
    };
  },

  personReadBegin: () => {
    return {
      type: actions.PERSON_READ_BEGIN,
    };
  },

  personReadSuccess: (data) => {
    return {
      type: actions.PERSON_READ_SUCCESS,
      data,
    };
  },

  personReadErr: (err) => {
    return {
      type: actions.PERSON_READ_ERR,
      err,
    };
  },

  personUpdateBegin: () => {
    return {
      type: actions.PERSON_UPDATE_BEGIN,
    };
  },

  personUpdateSuccess: (data) => {
    return {
      type: actions.PERSON_UPDATE_SUCCESS,
      data,
    };
  },

  personUpdateErr: (err) => {
    return {
      type: actions.PERSON_UPDATE_ERR,
      err,
    };
  },


  dailyworkAddBegin: () => {
    return {
      type: actions.DAILY_WORK_ADD_BEGIN,
    };
  },

  dailyworkAddSuccess: (data) => {
    return {
      type: actions.DAILY_WORK_ADD_SUCCESS,
      data,
    };
  },

  dailyworkAddErr: (err) => {
    return {
      type: actions.DAILY_WORK_ADD_ERR,
      err,
    };
  },

  personWorkReadBegin: () => {
    return {
      type: actions.PERSON_WORK_READ_BEGIN,
    };
  },

  personWorkReadSuccess: (data) => {
    return {
      type: actions.PERSON_WORK_READ_SUCCESS,
      data,
    };
  },

  personWorkReadErr: (err) => {
    return {
      type: actions.PERSON_WORK_READ_ERR,
      err,
    };
  },


};

export default actions;
